var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useIVASetChatStatus } from 'iva-react-web-ui';
import useSteps from '../../context/steps.context';
import { t } from '../../translations/getTranslation';
import useConfig from '../../context/config.context';
export const InlineCtaButton = styled.button `
  all: unset;
  color: ${({ theme }) => theme.colors.cyanBlue};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  cursor: pointer;

  &:focus {
    outline: 2px solid -webkit-focus-ring-color;
  }

  &:hover {
    text-decoration: underline;
  }
`;
export const OnlineChatButton = (_a) => {
    var { children, pointOfNeed } = _a, analyticsProps = __rest(_a, ["children", "pointOfNeed"]);
    const { pointOfNeedChat } = useIVASetChatStatus();
    const { stepsDispatch } = useSteps();
    const { accountId } = useConfig();
    const handleClick = () => {
        pointOfNeedChat(pointOfNeed !== null && pointOfNeed !== void 0 ? pointOfNeed : 'RC', accountId);
        stepsDispatch({
            type: 'closeFlow'
        });
    };
    return (_jsx(InlineCtaButton, Object.assign({ onClick: handleClick }, analyticsProps, { children: children })));
};
export const ReplacementCardOnlineChatButton = () => (_jsx(OnlineChatButton, Object.assign({ "data-type": "replacement card", "data-reason": "online chat", "data-object": "button", "data-analytics": "clicktrackingevent" }, { children: t('common.onlineChat') })));
export const ReplacementCardReportLostStolenChatButton = () => (_jsx(OnlineChatButton, Object.assign({ "data-type": "replacement card", "data-reason": "report lost or stolen", "data-object": "link", "data-analytics": "clicktrackingevent", pointOfNeed: "RLS" }, { children: t('reasonSelection.reportIt') })));
//# sourceMappingURL=index.js.map